import { serviceTrackingClick } from "../constants/constants";

/**
 * Class for tracking
 * 
 * eventName {String} PET_CLICK | REFUGE_CLICK
 * filters {Object}
 * browser {String}
 * device {String}
 * soruce {String} Relative url in browser
 * objectId {String} Id of the pet that was clicked
 * ip {String}
 */
class Tracking {
    constructor ({eventName, filters, browser, device, source, objectId, ip, osName, mobileVendor, state, experimentId}) {
        this.eventName = eventName;
        this.filters = filters;
        this.browser = browser;
        this.device = device;
        this.source = source;
        this.objectId = objectId;
        this.ip = ip;
        this.osName = osName;
        this.mobileVendor = mobileVendor;
        this.state = state;
        this.experimentId = experimentId
    }

    toJson() {
        const returnJson = {
          'event_name': this.eventName,
          'filters': this.filters,
          'browser': this.browser,
          'device': this.device,
          'source': this.source,
          'object_id': this.objectId,
          'ip': this.ip,
          'os_name': this.osName,
          'mobile_vendor': this.mobileVendor,
          'state': this.state
      };

      if (this.experimentId !== null && typeof this.experimentId !== "undefined") {
        returnJson['experiment_id'] = this.experimentId;
      }

      return returnJson;
    }

    async trackingPetClick() {
        const headers = {
          Accept: "application/json",
          "Content-Type": "application/json",
        };
    
        const options = {
          method: "POST",
          body: JSON.stringify(this.toJson()),
          headers: headers,
        };
    
        await fetch(serviceTrackingClick, options);
      }
}

export default Tracking;